const cookie = require('cookie_js').cookie;
const text = require('./text.yaml')[templateVars.lang];
const config = require('./config.yaml')[templateVars.lang];

let hopscotch = false;
let tourQueue = [];

function setTourStatus(status, id, lang) {
	global[`${status}_${id}_${lang}`] = true;
	$(window).trigger(status, [id, lang]);
}

function makeToursQueue(tours) {
	let queue = [];

	for (let i in tours) {
		const tour = tours[i];
		const $targetItem = $(tour.steps[0].target);

		if ($targetItem.length && !cookie(`tourPassed_${tour.id}_${templateVars.lang}`)) {
			queue.push(tour);
		}
	}

	return queue;
}

function startToursQueueItem(tourConfig, queueIndex = 0) {
	const nextIndex = ++queueIndex;

	if (typeof tourQueue[nextIndex] != 'undefined') {
		tourConfig.onClose = () => {
			startToursQueueItem(tourQueue[queueIndex], nextIndex);
		};
	}

	const tour = new Tour(tourConfig);
	tour.startFirstTime();
}

/**
 * Тур по странице
 */
class Tour {
	constructor(config) {
		this.cookieName = `tourPassed_${config.id}_${templateVars.lang}`;
		this.config = config;
		this.config.i18n = text;
		this.config.cookieName = this.cookieName;
		this.config.onStart = () => {
			setTourStatus('tourStart', this.config.id, templateVars.lang);
		};
	}

	/**
	 * Начать тур по странице
	 */
	start(forceClearCurrent = false) {
		if (!hopscotch) {
			require.ensure(['hopscotch', './hopscotch.css'], require => {
				hopscotch = require('hopscotch');
				require('./hopscotch.css');
				hopscotch.startTour(this.config);
			});
		} else {
			hopscotch.endTour(false);
			setTimeout(() => {
				hopscotch.startTour(this.config);
			}, 200);
		}
	}

	/**
	 * Начать тур по странице единожды (если тур уже был показан, то не показывать ещё раз)
	 */
	startFirstTime() {
		if (!cookie(this.cookieName)) {
			this.start();
			cookie.set(this.cookieName, 'true', {
				path: '/',
				expires: 365
			});
		} else {
			setTourStatus('tourSkipped', this.config.id, templateVars.lang);
		}
	}

	/**
	 * Проверить наличие куков для текущего тура
	 */
	checkCookie() {
		return cookie(this.cookieName);
	}
}

tourQueue = makeToursQueue(config);

if (tourQueue.length) {
	startToursQueueItem(tourQueue[0], 0);
}


/** @global */
global.Tour = Tour;
/** Tour */
module.exports = Tour;



// WEBPACK FOOTER //
// ./temp/components/tour/index.js